var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"profile-gallery"},[_c('viewer',{staticClass:"images-list",class:( _obj = {}, _obj['box-margins'] = !!_vm.boxMargins, _obj ),attrs:{"images":_vm.images}},_vm._l((50),function(i){return _c('img',{key:i,attrs:{"src":'/static/images/gallery/photo-'+i+'.jpg',"alt":"gallery image"}})}))],1)
var _obj;}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51a31cfa","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Profile/ProfileGallery.vue
// module id = null
// module chunks = 